import React from 'react'
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
const Puz24 = () => {
    return (
        <div>
            <NavLink to='/category/Puzzels/Puzzel25'>
<Button variant="contained" color="primary" style={{float:'right', margin:'25px',marginRight:'80px'}}>Next page -&gt; </Button>
</NavLink> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<NavLink to='/category/Puzzels/Puzzel23'>
<Button variant="contained" color="primary" style={{float:'left', margin:'25px',marginLeft:'70px'}}>&lt;-   Previous page </Button>
</NavLink>
<article class="container">
    <h1 class="title">10 Coins Puzzle</h1>
    
    <div class="text">
        <p>You are blindfolded and 10 coins are place in front of you on table. You are allowed to touch the coins, but
            can’t tell which way up they are by feel. You are told that there are 5 coins head up, and 5 coins tails up
            but not which ones are which.</p>
        <p>Can you make two piles of coins each with the same number of heads up? You can flip the coins any number of
            times.</p>
        <p><br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
        </p>
        <div class="containers">
        <p><strong>ANSWER:</strong></p>
        <p><strong>Yes</strong></p><br/>

       

        <p><strong>Explanation:</strong></p>
        <p>Make 2 piles with equal number of coins. Now, flip all the coins in one of the pile.</p>
        <p>Let’s consider a simple case:</p>
        <p><strong>P1 :</strong> H T T T T<br/>
            <strong>P2 :</strong> H H H H T</p>
        <p>By filping <strong>P1</strong></p>
        <p><strong>P1 :</strong> T H H H H</p>
        <p><strong>P2 :</strong> H H H H T</p>
        <p><strong>P1</strong>(heads) = <strong>P2</strong>(heads)</p>
        <p><br/>
        </p>
       
    </div></div>
</article>
        </div>
    )
}

export default Puz24
